import { Injectable, inject } from '@angular/core';
import {Location} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HydraService} from '../../../core/services/hydra.service';
import {api} from '../../../api/api-dictionnary';
import {HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {UtilisateurSignature} from '../../../class/api/UtilisateurSignature';
import {Fichier} from '../../../interface/api/Fichier';
import {HydraInterface} from '../../../class/generic/hydra';

@Injectable()
export class ToolsService {
    snackBar = inject(MatSnackBar);
    private location = inject(Location);
    private hydraService = inject(HydraService);
    private translationService = inject(TranslateService);



    // Emettre un événement JS au navigateur
    public dispatchEvent(eventName) {
        setTimeout(() => {
            window.dispatchEvent(new Event(eventName));
        }, 100);
    }

    // Toaster notifications
    public notificationSuccess(message: string, timer: number = 5000) {
        this.snackBar.open(message, 'Fermer', {
            duration: timer,
            panelClass: 'successNotif',
            horizontalPosition: 'right',
        });
    }

    public notificationError(message: string, timer: number = 25000) {
        this.snackBar.open(message, 'Fermer', {
            duration: timer,
            panelClass: 'errorNotif',
            horizontalPosition: 'right',
        });
    }

    public notificationInfo(message: string, timer: number = 5000) {
        this.snackBar.open(message, 'Fermer', {
            duration: timer,
            panelClass: 'infoNotif',
            horizontalPosition: 'right',
        });
    }

    /*    public notificationWarning(message: string, timer: number) {
            this.snackBar.open(message, "Fermer", {
                duration: timer,
                panelClass: "warningNotif",
            });
        }*/

    public compareByid(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.id == itemTwo.id;
    }

    public convertDateForFront(str: any) {
        if (str != undefined && str != null) {
            return str.substring(0, 10);
        } else {
            return '';
        }
    }

    public convertDateToMonth(str: any) {
        if (str != undefined && str != null) {
            return str.substring(0, 7);
        } else {
            return '';
        }
    }

    public convertDateToDateTimePicker(date: Date = new Date()) {
        return (
            date.getFullYear() +
            '-' +
            this.dateSi1Ajouter0(+date.getMonth() + 1 + '') +
            '-' +
            this.dateSi1Ajouter0(date.getDate() + '') /*+
            "T" +
            this.dateSi1Ajouter0(date.getHours() + "") +
            ":" +
            this.dateSi1Ajouter0(date.getMinutes() + "")*/
        );
    }

    public isDateCorrect(date: Date) {
        if (date.getDate() < 1) {
            return false;
        }
        if (date.getMonth() < 0) {
            return false;
        }
        if (date.getFullYear() < 1000) {
            return false;
        }
        return true;
    }

    private dateSi1Ajouter0(elem: string) {
        if (elem.length == 1) {
            return '0' + elem;
        }
        return elem + '';
    }

    public stripAccent(elem: string) {
        return elem.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    /**
     *
     * @param research
     * @param researchIndex
     * @param dataSource
     * @returns
     */
    public filterForNgModelAutoComplete(
        research: any,
        researchIndex: string = null,
        dataSource: any[]
    ) {
        let str = '';

        if (typeof research == 'string') {
            str = research.toLowerCase();
        }
        if (researchIndex != null && typeof research == 'object') {
            str = research[researchIndex].toLowerCase();
        }

        const dataFiltered = dataSource.filter(item => {
            if (item[researchIndex].toLowerCase().indexOf(str) != -1 || !str) {
                return item;
            }
        });
        return dataFiltered;
    }

    public replaceUrl(str: string) {
        this.location.replaceState('');
    }

    /**
     * @deprecated use getGUID() instead
     */
    public guidGenerator() {
        return this.getGUID();
    }

    public getGUID(): string
    {
        const S4 = function() {
            return (((1 + Math.random()) * 0x10000) | 0)
                .toString(16)
                .substring(1);
        };
        return (
            S4() +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            S4() +
            S4()
        );
    }

    public compareByIri(itemOne, itemTwo) {
        //Optimisation en plusieurs étapes pour les performancens
        if (
            itemOne == null ||
            itemOne == undefined ||
            typeof itemOne == 'string'
        ) {
            return false;
        }
        if (
            itemTwo == null ||
            itemTwo == undefined ||
            typeof itemTwo == 'string'
        ) {
            return false;
        }
        return (
            typeof itemOne == 'object' &&
            typeof itemTwo == 'object' &&
            itemOne['@id'] == itemTwo['@id']
        );
    }

    public compareByApiResource(a: string | HydraInterface, b: string | HydraInterface){
        const aIri = typeof a === 'string' ? a : a['@id'];
        const bIri = typeof b === 'string' ? b : b['@id'];
        return aIri === bIri;
    }

    public compareByValue(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    public convertDate10(value) {
        if (+value < 10) {
            return '0' + value;
        }
        return value;
    }


    public static generateTempUniqueId(): string {
        return Math.random() + '_' + Date.now() + '_' + Math.random();
    }

    public async downloadCsv(
        file: Fichier | { url: string; originalFilename?: string },
        options?: {
            headers?: HttpHeaders | {
                [header: string]: string | string[];
            };
            params?: HttpParams | {
                [param: string]: string | string[];
            };
            reportProgress?: boolean;
            withCredentials?: boolean;
        }
    ) {
        return this.download(
            file,
            {
                ...options,
                headers: {
                    ...options?.headers,
                    Accept: 'text/csv'
                }
            }
        );
    }

    public async download(
        file: Fichier | { url: string; originalFilename?: string },
        options?: {
            headers?: HttpHeaders | {
                [header: string]: string | string[];
            };
            params?: HttpParams | {
                [param: string]: string | string[];
            };
            reportProgress?: boolean;
            withCredentials?: boolean;
        }
    ) {
        return new Promise<void>((resolve, reject) => {
            this.hydraService.getBinary(file.url, options).subscribe(
                (res) => {
                    const filename: string = file.originalFilename ?? HydraService.getFileNameFromResponseContentDisposition(res);
                    const url = window.URL.createObjectURL(res.body);
                    const link = document.createElement('a');
                    link.setAttribute('href', url);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    resolve();
                },
                err => reject(err)
            );
        });
    }

    public getAides() {
        return this.hydraService.getList(api.aides + '?pagination=false&replaceGroups[]=AideListHeavy'
            + '&replaceGroups[]=CommissionSeanceEmbedRead'
            + '&replaceGroups[]=CommissionEmbedRead'
            + '&replaceGroups[]=CommissionTypeRead'
            + '&replaceGroups[]=UtilisateurMinimal'
            + '&order[label]=asc'
        );
    }

    public getAideSousTypes() {
        return this.hydraService.getList(api.aideSousType + '?pagination=false');
    }

    public getCommissions() {
        return this.hydraService.getList(api.commissions + '?pagination=false', true);
    }

    public getCommissionSeances() {
        return this.hydraService.getList(api.commissionSeances + '?pagination=false', false);
    }

    public getCommissionExpert(commissionSeances) {
        const reunions = commissionSeances.filter(
            element => element.commission.commissionType.code === 'CN'
        );

        if(reunions.length > 0) {
            return reunions[0];
        }
    }


    private violationsArrayExist(response: HttpErrorResponse): boolean {
        return (response && response.status == 400 && response.error && response.error.violations.length);
    }

    private getErrorFromViolationsArray(response: { error: { violations: [] } }, pathKeyOrMessage): any[] {
        const violation = response.error.violations.filter((item: { message; propertyPath }) => (item.propertyPath === pathKeyOrMessage || item.message.indexOf(pathKeyOrMessage) != -1));
        return violation;
    }

    public errorsProfilManager(errors: string[], response: HttpErrorResponse) {
        if (this.violationsArrayExist(response)) {
            errors.forEach(errorKey => {
                switch (errorKey) {
                    case 'adresseExistante' : {
                        const key = 'front.inscription.adresseExistante';
                        const violation = this.getErrorFromViolationsArray(response, key);
                        if (violation.length) {
                            const sub = this.translationService.get(key).subscribe(res => {
                                this.notificationError(res, 5000);
                                return res;
                            });
                            setTimeout(() => {
                                sub.unsubscribe();
                            }, 100);
                        }
                    }
                        break;
                    case 'doublonNomPrenomDate' : {
                        const key = 'front.inscription.doublonNomPrenomDate';
                        const violation = this.getErrorFromViolationsArray(response, key);
                        if (violation.length) {
                            const sub = this.translationService.get(key).subscribe(res => {
                                this.notificationError(res, 5000);
                                return res;
                            });
                            setTimeout(() => {
                                sub.unsubscribe();
                            }, 100);
                        }
                    }
                        break;
                }
            });
        }
    }

    public getLastSignatureFromCode(code: string, signatures: UtilisateurSignature[]): UtilisateurSignature | null {
        const signaturesByCode = signatures.filter(signature => signature.code === code);
        const signatureOrderedByDate = signaturesByCode.sort((a, b) =>
            // @ts-ignore
             new Date(b.dateSignature) - new Date(a.dateSignature) as any
        );
        return (signatureOrderedByDate.length) ? signatureOrderedByDate[0] : null;
    }

    public copy(str: string) {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.notificationSuccess('Copy ✓', 2000);
    }

    /**
     * @desc Ne fonctionne pas avec des objets typé exemple a.b ( b = ExDossier | Date ou autre ...)
     * @param obj
     */
    public deepCloneQuill<T>(obj: T): {} {
        return JSON.parse(JSON.stringify(obj));
    }

    public compareForSorting(a: number | string, b: number | string, isAsc: boolean = true) {
        if(typeof a == 'string' && typeof b == 'string') {
            a = a.toLowerCase();
            b = b.toLowerCase();
        }
        return (a < b ? -1 : (a > b ? 1 : 0)) * (isAsc ? 1 : -1);
    }
}


